export default __webpack_public_path__ + "static/media/logoColor.0959e307.svg";